// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1Ub6a","bigColWidth":"Table_bigColWidth__3895R","biggerColWidth":"Table_biggerColWidth__2xBbE","row":"Table_row__2YmaB","col":"Table_col__15hPe"};